import { render, staticRenderFns } from "./VendorPaymentsPending.vue?vue&type=template&id=a88e036e"
import script from "./VendorPaymentsPending.vue?vue&type=script&lang=js"
export * from "./VendorPaymentsPending.vue?vue&type=script&lang=js"
import style0 from "./VendorPaymentsPending.vue?vue&type=style&index=0&id=a88e036e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports